// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"61c72d30","387":"c87d383c","494":"8049f2a7","640":"ccc00b9e","787":"2abb59a0","985":"49f3603a"}[chunkId] + ".chunk.js";
};